import type { ComponentType } from 'react';
import { Serializable } from './serializable';

type DashboardPlugin = {
  id: string;
  title: string;
  Component: ComponentType;
};

type DashboardMenuPlugin = {
  id: string;
  title: string;
  subtitle?: string;
  isPermitted: boolean;
  IconComponent?: ComponentType;
  IconSmallComponent?: ComponentType;
  action: (params?: Record<string, Serializable>) => void;
};

/** @internal */
export type GetDashboardPlugins = (
  slotId: string,
  options?: {
    skeletonClassName?: string;
    permissionStrategy?: 'filter' | 'no-permitted-widget' | 'ignore';
  },
) => DashboardPlugin[];

/** @internal */
export type GetDashboardMenuPlugins = (
  slotId: string,
  options?: {
    permissionStrategy?: 'filter' | 'ignore';
  },
) => DashboardMenuPlugin[];
